import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-invigidashboard',
  templateUrl: './invigidashboard.component.html',
  styleUrls: ['./invigidashboard.component.css']
})
export class InvigidashboardComponent implements OnInit {

  public invigilator_name: any;
  public invigilator_role: any;
  loginForm: any;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  ngOnInit(): void {

    this.checkLogin();

    this.loginForm = this.formBuilder.group({
      email: window.localStorage.getItem('email'),
      mobileno: window.localStorage.getItem('mobile'),
    });

    this.api
      .checkLogin(this.loginForm.value)
      .subscribe((result: any) => {

        this.invigilator_name = result.name;
        this.invigilator_role = result.role;

      });

  }

  logout() {
    this.router.navigateByUrl('/invigilatorAdmin');
    window.localStorage.removeItem('invigilator_logged_in');
    window.localStorage.removeItem('email');
    window.localStorage.removeItem('mobile');
  }

  checkLogin() {
    if (window.localStorage.getItem('mobile') == 'undefined' || window.localStorage.getItem('email') == 'undefined') {
      this.logout();
    }
  }

}
